import * as actionTypes from '../actions/actionTypes';
import { updateObject } from '../utility';

const initialState = {
    appointments: []
};

const appointmentHistoryGet = ( state, action ) => {
    return updateObject( state, 
        { 
            appointments: action.appointments,
        } 
    );
};

const reducer = ( state = initialState, action ) => {
    switch ( action.type ) {
        case actionTypes.APPOINTMENT_HISTORY_GET: return appointmentHistoryGet(state, action);
        default:
            return state;
    }
};

export default reducer;


// WEBPACK FOOTER //
// ./src/store/reducers/appointmentHistory.js